import { render, staticRenderFns } from "./pointer-list.vue?vue&type=template&id=4ca3b18c&scoped=true&"
import script from "./pointer-list.vue?vue&type=script&lang=js&"
export * from "./pointer-list.vue?vue&type=script&lang=js&"
import style0 from "./pointer-list.vue?vue&type=style&index=0&id=4ca3b18c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca3b18c",
  null
  
)

export default component.exports